type Token = {
  created: string;
  objectId: string;
  response?: {
    data?: {
      message: string;
    };
    status: number;
  };
  test: boolean;
  token: string;
  user: string;
};

interface JSONToken {
  created: string;
  object_id: string;
  test: boolean;
  token: string;
  user: string;
}

const fromJSON = (token: JSONToken) => {
  const serialized: Token = {
    created: token.created,
    objectId: token.object_id,
    test: token.test,
    token: token.token,
    user: token.user,
  };

  return serialized;
};

export { JSONToken, Token, fromJSON };
